import {Typography} from '@sollapay/ui';
import {formatNIS} from '@sollapay/utils';
import {useTranslation} from 'react-i18next';

import {getAssetFeedSubtitle} from '@/features/buyers/utils';
import {useTrustTypeStrategy} from '@/features/trust-accounts/providers';

import {ACTIVITY_ICONS} from '../activity-presentation';
import {ActivityFeedRowLayout} from '../ActivityFeedRowLayout';
import {BuyerNamesSummary} from './BuyerNamesSummary';
import {castMetadata, readAssetSummary, readBuyerNames} from './metadata.utils';

import type {BuyerOverpaymentMetadata, TrustAccountActivityDTO} from '@sollapay/types';

export interface BuyerOverpaymentRowProps {
  activity: TrustAccountActivityDTO;
}

/** The paired deposit row already shows the full credit, so the excess is neutral text, not a second credit badge. */
export function BuyerOverpaymentRow({activity}: BuyerOverpaymentRowProps) {
  const {t} = useTranslation('trustAccounts');
  const {allowsMultipleAssets} = useTrustTypeStrategy();
  const meta = castMetadata<BuyerOverpaymentMetadata>(activity);
  const buyerNames = readBuyerNames(meta);

  return (
    <ActivityFeedRowLayout
      icon={ACTIVITY_ICONS[activity.activityType]!}
      title={t(`view.activity.activityType.${activity.activityType}`)}
      actorName={buyerNames.length > 0 ? <BuyerNamesSummary buyerNames={buyerNames} /> : null}
      subtitle={getAssetFeedSubtitle(readAssetSummary(activity), t, allowsMultipleAssets)}
      createdAt={activity.createdAt}
      action={
        meta?.excessAmount ? (
          <Typography dir="ltr" color="secondary" weight="semibold">
            {formatNIS(meta.excessAmount)}
          </Typography>
        ) : undefined
      }
    />
  );
}
